import { render, staticRenderFns } from "./CoursePage.vue?vue&type=template&id=49c30dba&scoped=true"
import script from "./CoursePage.vue?vue&type=script&lang=js"
export * from "./CoursePage.vue?vue&type=script&lang=js"
import style0 from "./CoursePage.vue?vue&type=style&index=0&id=49c30dba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c30dba",
  null
  
)

export default component.exports